import React, { useState } from 'react'
import { Org } from '../../../organisations/OrganisationAccounts/types'
import { Tooltip } from '@material-ui/core'
import { copyStringToClipboard } from '../../../../common/utilities/dom'
import { Autocomplete, Option } from 'tinybots-react-components'

export const OrganisationsSearch = ({ organisations }: { organisations: Org[] }) => {
  const relationOptions = organisations.map(org => ({
    key: org.relationId,
    label: `${org.relationId} - ${org.name}`
  }))

  const [selectedOption, setSelectedOption] = useState<Option>()
  const [copiedMessage, setCopiedMessage] = useState(false)
  return (
    <Tooltip
      title="Copied to clipboard"
      open={copiedMessage}
      disableFocusListener
      disableHoverListener
      disableTouchListener
    >
      <div style={{ width: '380px' }}>
        <Autocomplete
          options={relationOptions}
          value={selectedOption}
          onChange={(option: Option) => {
            setSelectedOption(option)
            copyStringToClipboard(String(option?.key))
            setCopiedMessage(true)
          }}
          placeholder="Search and copy relation id of organisation"
        />
      </div>
    </Tooltip>
  )
}
